// extracted by mini-css-extract-plugin
export default {"mainContainer":"ExtraImages_mainContainer__Bc+Gb","image":"ExtraImages_image__LSnB6"};